var EquipmentsComponentModule = /** @class */ (function () {
    function EquipmentsComponentModule() {
    }
    return EquipmentsComponentModule;
}());
export { EquipmentsComponentModule };
